// extracted by mini-css-extract-plugin
export default {"indicator":"_2cbfX","blink":"Y5S2K"};